<template>
  <div class="main">
    <div class="main-login" :style="{ height: mainHeight }">
      <el-card class="main-login-card">
        <div class="login-card-title">
          <span class="fs30 lh40 fwb" style="textAlign:center;display:block">账号登录</span>
        </div>
        <el-form label-position="top" :model="loginForm" :rules="rules" ref="loginForm">
          <el-form-item label="账户" prop="user">
            <el-input v-model="loginForm.user" suffix-icon="el-icon-user-solid"></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input v-model="loginForm.password" show-password suffix-icon="el-icon-lock"></el-input>
          </el-form-item>
          <el-form-item label="验证码" prop="verification">
            <el-input v-model="loginForm.verification" style="width:300px" @keyup.enter.native="login"></el-input>
            <el-image style="width: 100px; height: 40px" @click="getVerificationCode" :src="verificationCodeImage" alt="点击刷新"></el-image>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" style="width:100%" @click="login" :loading="loginLoading">登录</el-button>
          </el-form-item>
        </el-form>
      </el-card>
    </div>
  </div>
</template>

<script>
import { JSEncrypt } from "jsencrypt";
import URL from '../../utils/url'
import { sendWebsocket, closeWebsocket } from '../../utils/websocket'
// 公钥
const PUBLIC_KEY = "MFwwDQYJKoZIhvcNAQEBBQADSwAwSAJBAK4nqGQWkLkZMEDR4ARpN6LG2P0r4F7dmJ7yQOTOoMfG3JXoOO8mrooUoBjJR8FdxkO3Z0s9abAe0DGu+BrITw0CAwEAAQ==";
// 私钥
const PRIVATE_KEY =
  "MIIBVAIBADANBgkqhkiG9w0BAQEFAASCAT4wggE6AgEAAkEArieoZBaQuRkwQNHgBGk3osbY/SvgXt2YnvJA5M6gx8bcleg47yauihSgGMlHwV3GQ7dnSz1psB7QMa74GshPDQIDAQABAkEAj+zEVBr19ZKkdx07ZknSKdrtnqTxI1U8+Ta5fJ5q703DIg58HEkOPnSHQy1sjF5hnG7/O8gN+eq2yjJyhuOFgQIhANTXkG7IsQt5X3fpztX16jiYv6utBGMwqzwF8s/R0TAhAiEA0XfhPpjWwfTLCu1MW86uFWT4/eL/tNrGycCm0pRwsW0CIHT76mnJqu3Ijz2EZ+fX2x2ybx734MJ3/JXoGxY4l4ahAiALaQ5aDJVWR3FwDPEl5yJQhAmUOvNW9LvzbY0o13E0GQIgVfMKsZjSYJVxpkDo+//YF57A8qRMuSGJoSxZX6Z7SDI=";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      loginForm: {
        user: "", //用户名
        password: "", //密码
        verification: "", //验证码
      },
      mainHeight: "", //轮播图高度
      timestamp: "", //随机数
      verificationCodeImage: "", //code图
      loginLoading: false,
      rules: {
        //验证规则
        user: [{ required: true, message: "请输入账户", trigger: "blur" }],
        // password: [
        //   { required: true, message: '请输入密码', trigger: 'blur' },
        //   { pattern: /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^[^\s\u4e00-\u9fa5]{6,18}$/, message: '密码为6-18位,至少包含数字、字母、符号中的两种，并且不能包含中文和空格', trigger: 'blur' }
        // ],
        verification: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getUserPassword()
    this.getVerificationCode();
    this.mainHeight = document.body.clientHeight - 374 < 480 ? "480px" : document.body.clientHeight - 374 + "px";
  },
  methods: {
    ...mapMutations(["recordUserInfo", "changeRouting"]),
    // 获取验证码
    getVerificationCode() {
      this.timestamp = `${Date.parse(new Date()) / 1000}${Math.ceil(Math.random() * 1000000)}`;
      this.$user.randomImage(this.timestamp).then((res) => {
        if (res.data.success) {
          this.verificationCodeImage = res.data.result;
        }
      });
    },
    // 登录
    login() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loginLoading = true;
          this.$user
            .login({
              captcha: this.loginForm.verification,
              checkKey: this.timestamp,
              passWord: this.loginForm.password,
              userName: this.loginForm.user,
            })
            .then((res) => {
              if (res.data.code == 200) {
                this.saveLoginAccount()
                this.$store.commit('SET_NUM',0)
                sessionStorage.setItem("token", res.data.result.token);
                this.openWs()
                // sessionStorage.setItem("jurisdiction", [1, 2, 3, 4, 5]);
                this.recordUserInfo(res.data.result.userInfo);
                this.$router.replace({ path: "/management" });
              } else {
                this.getVerificationCode();
              }
            })
            .finally(() => {
              this.loginLoading = false;
              // console.log('kk')
            });
        } else {
          return false;
        }
      });
    },
    // 处理动态路由
    amendRouter(routes) {
      routes.forEach((item) => {
        item.component = this.remould(item.component);
        if (item.children) {
          this.amendRouter(item.children);
        }
      });
    },
    // 处理route中组件引入
    remould(route) {
      return () => import(`@/${route}`);
    },
    // 登录保存密码处理
    saveLoginAccount() {
      localStorage.setItem('yxo_user', this.encryption(this.loginForm.user))
      localStorage.setItem('yxo_password', this.encryption(this.loginForm.password))
    },
    // 获取账号密码
    getUserPassword() {
      if (localStorage.getItem('yxo_user')) {
        this.loginForm.user = this.decode(localStorage.getItem('yxo_user'))
        this.loginForm.password = this.decode(localStorage.getItem('yxo_password'))
      }
    },
    // 加密
    encryption(data) {
      const encryptor = new JSEncrypt();
      encryptor.setPublicKey(PUBLIC_KEY); // 设置公钥
      return encryptor.encrypt(data); // 对需要加密的数据进行加密
    },
    // 解密
    decode(data) {
      const encryptor = new JSEncrypt();
      encryptor.setPrivateKey(PRIVATE_KEY);
      return encryptor.decrypt(data);
    },
    openWs() {
      closeWebsocket()
      sendWebsocket(`wss://${URL}/websocket`, {}, this.wsMessage, this.wsError)
    },
    wsMessage(e) {
      if (e.topic) {
        this.$alert(e.topic, '提示', {
          confirmButtonText: '确定'
        });
      }
    },
    wsError() {
      // 比如取消页面的loading
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  .main-login {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    .main-login-card {
      width: 500px;
      position: relative;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%); /* 50%为自身尺寸的一半 */
      z-index: 99;
      .login-card-title {
        margin-bottom: 48px;
      }
      /deep/.el-form--label-top .el-form-item__label {
        padding: 0;
      }
      /deep/.el-form-item__label {
        font-size: 16px;
        line-height: 20px;
        color: #666666;
      }
      /deep/.el-input__inner {
        border-width: 0;
        border-radius: 0;
        padding: 0;
        border-bottom-width: 1px;
        font-size: 18px;
      }
      .el-form-item__content .el-image {
        vertical-align: middle;
        margin-left: 10px;
        cursor: pointer;
      }
    }
    /deep/.el-card__body {
      padding: 40px;
    }
  }
  .main-contact {
    width: 1200px;
    margin: 0 auto;
    padding: 32px 0;
    h4 {
      font-size: 20px;
      line-height: 26px;
      color: #363636;
      margin-bottom: 16px;
      font-weight: bold;
    }
    p {
      font-size: 14px;
      line-height: 20px;
      color: #363636;
      margin-bottom: 16px;
    }
    .main-contact-code {
      text-align: center;
      .el-image {
        margin-bottom: 10px;
      }
    }
  }
}

/deep/.el-icon-user-solid:before,
/deep/.el-icon-lock:before {
  font-size: 24px;
}

/deep/.el-icon-view:before {
  font-size: 18px;
}
</style>
